import { createTheme } from '@one-thd/sui-atomic-components';

const MothersDaySecondaryTwo = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

MothersDaySecondaryTwo.palette['--sui-palette-background-primary'] = '247 185 158';

export { MothersDaySecondaryTwo };
